import { render, staticRenderFns } from "./sort-value-modal.vue?vue&type=template&id=4fbf1ca4"
import script from "./sort-value-modal.vue?vue&type=script&lang=js"
export * from "./sort-value-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports